<div>
  <form [formGroup]="EOI_form">
    <div class="row mt-3 mb-4 align-items-center" style="margin-left: 23px">
      <div class="col-sm-6 d-flex align-items-baseline p-0">
        <p class="_fw-600">Sale Type</p>
        <div class="p-field-radiobutton d-flex align-items-center ml-4 mr-3">
          <p-radioButton name="sale_type" value="retail" formControlName="sale_type"></p-radioButton>
          <label for="sale_type" class="pl-2 f-10 mb-1">Retail</label>
        </div>
        <div class="p-field-radiobutton d-flex align-items-center">
          <p-radioButton name="sale_type" value="agent" formControlName="sale_type"></p-radioButton>
          <label for="sale_type" class="pl-2 f-10 mb-1">Agent</label>
        </div>
      </div>
      <!-- *ngIf="
          this.userPermission.includes('contract.manage') ||
          this.userPermission.includes('contract.edit') ||
          this.userRole == 'master admin' ||
          this.userRole == 'operations manager'
        " -->
      <div class="col-sm-6 text-right {{ isMobile_device ? 'mt-3' : '' }}">
        <button class="_addNew p-2" (click)="isEOIEdit = !isEOIEdit; this.patchEditForm(this.selected_eoi?._id, false)" *ngIf="allowEdit()">
          <img [src]="common_images?.edit_icon" class="cursor-pointer" width="16px" />
        </button>
        <ng-container *ngIf="isEOIEdit">
          <button class="_cancel-btn mx-2 bg-white" (click)="closeEOI()" *ngIf="!isMobile_device">Close</button>
          <button class="mr-2 _outline-btn bg-white" (click)="saveEOI('onlyCreate')" *ngIf="!isCreateNew">Save</button>
          <button class="_primary-btn" (click)="saveEOI('create')">Save & Close</button>
        </ng-container>
      </div>
    </div>

    <!-- The link lives on the EOI: copy, reopen or reissue it without going
         back to the project's External EOI tab. Generating a new link happens
         from the lead, not here — a separate "External EOI Link" trigger on
         this page duplicated that entry point and was how a record ended up
         with more than one link generated against it. A new EOI has no id
         yet, so the panel renders nothing until one exists. -->
    <app-external-eoi-links
      #eoiLinks
      [projectId]="externalEoiProjectId"
      [eoiId]="isCreateNew ? null : selected_eoi?._id || null"
      [agentName]="selected_eoi?.agent_name"
      [canManage]="allowEdit()"></app-external-eoi-links>

    <div class="popup-box mt-2 mb-3">
      <ng-container *ngIf="isEOIEdit; else noEOIEdit">
        <div class="row">
          <div class="col-sm-3 project-link">
            <p class="f-12 mb-2">Project</p>
            <ng-select
              class="ng-site-input"
              formControlName="projectid"
              [items]="lmService.ProjectList"
              [multiple]="false"
              bindLabel="Project_Name"
              bindValue="_id"
              [searchable]="true"
              placeholder="Select"
              [clearable]="false">
              <ng-template ng-label-tmp let-item="item">
                <div class="d-flex align-items-center cursor-pointer">
                  <i class="pi pi-times-circle cursor-pointer" (click)="clear(item?._id, 'projectid'); $event.stopPropagation()"></i>
                  <p class="ml-2 ng-value-label" (click)="openModal(item, 'project')">{{ item.Project_Name }}</p>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                <span>{{ item.Project_Name }}</span>
              </ng-template>
            </ng-select>
          </div>
          <div class="col-sm-3 project-link">
            <p class="f-12 mb-2">Lot</p>
            <ng-select
              formControlName="unit_id"
              [items]="isCreateNew ? lmService.available_List : lmService.unitList"
              [multiple]="false"
              bindLabel="lot_name"
              bindValue="_id"
              [searchable]="true"
              placeholder="Select"
              [clearable]="true">
              <ng-template ng-label-tmp let-item="item">
                <div class="d-flex align-items-center cursor-pointer">
                  <i class="pi pi-times-circle cursor-pointer" (click)="clear(item?._id, 'unit_id'); $event.stopPropagation()"></i>
                  <p class="ml-2 ng-value-label" (click)="openModal(item, 'unit')">{{ item.lot_name }}</p>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                <span>{{ item.lot_name }}</span>
              </ng-template>
            </ng-select>
          </div>
          <div class="col-sm-3">
            <p class="f-12 mb-2">Status Reason</p>
            <ng-select
              [items]="status_reason"
              bindLabel="tag_name"
              bindValue="tag_name"
              [searchable]="true"
              placeholder="Select"
              [clearable]="false"
              formControlName="status_reason"
              (change)="changeEOIStatus()">
            </ng-select>
          </div>
          <div class="col-sm-3 d-flex align-items-center justify-content-between">
            <p class="f-12 mb-2">Assign</p>
            <div class="switch-button">
              <button [ngClass]="price_term === true ? 'switch-button-yes-class' : 'button-non-class'" (click)="price_term = true">Yes</button>
              <button [ngClass]="price_term !== true ? 'switch-button-no-class' : 'button-non-class'" (click)="price_term = false">No</button>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-template #noEOIEdit>
        <div class="d-flex align-items-center gap-3 flex-wrap">
          <div class="d-flex flex-column w-230px">
            <label class="pb-6px f-12 _fw-600" for="lead_category">Project</label>
            <p class="text-capitalize _fw-400">{{ selected_EOI?.project_name }}</p>
          </div>
          <div class="d-flex flex-column w-230px">
            <label class="pb-6px f-12 _fw-600" for="lead_category">Lot</label>
            <p class="text-capitalize _fw-400">{{ selected_EOI?.unit_name }}</p>
          </div>
          <div class="d-flex flex-column w-230px">
            <label class="pb-6px f-12 _fw-600" for="lead_category">Status Reason</label>
            <p class="text-capitalize _fw-400">{{ EOI_form.controls['status_reason'].value }}</p>
          </div>
          <div class="d-flex flex-column w-230px">
            <label class="pb-6px f-12 _fw-600" for="lead_category">Assign</label>
            <p class="text-capitalize _fw-400">{{ price_term === true ? 'Yes' : 'No' }}</p>
          </div>
        </div>
      </ng-template>
    </div>
    <ng-container *ngIf="isMobile_device; else noMobile">
      <div class="mobile-tab my-3">
        <p>{{ selectedItem ? selectedItem : 'Critical Date' }}</p>
        <i class="pi pi-chevron-down f-14 mobile-tab-icon cursor-pointer" (click)="showMenu = !showMenu"></i>
        <ng-container *ngIf="showMenu">
          <ul class="mobile-tab-menu">
            <li *ngFor="let item of menu_items; let i = index" (click)="selectItem(item, i)">
              {{ item?.name }}
            </li>
          </ul>
        </ng-container>
      </div>
    </ng-container>
    <ng-template #noMobile>
      <div class="d-flex align-items-center lead-secondary-tabs b-b-tabs">
        <ul class="nav tools-tab-nav w-100 align-items-end" role="tablist">
          <li
            class="nav-item cursor-pointer position-relative {{ tabIndexValue === 0 ? 'active' : '' }}"
            role="presentation"
            (click)="tabIndexValue = 0">
            <a
              [id]="'pills-critical_date'"
              data-bs-toggle="pill"
              (click)="is_notes = false"
              [attr.data-bs-target]="'#critical_date' + eoiTabIndex"
              role="tab"
              [attr.aria-controls]="'critical_date' + eoiTabIndex"
              aria-selected="false">
              <img src="assets/img/dashboadIcon/calendar-v2.svg" alt="" class="mr-2" />
              Critical Dates
            </a>
          </li>
          <li
            class="nav-item cursor-pointer position-relative {{ tabIndexValue === 1 ? 'active' : '' }}"
            role="presentation"
            (click)="tabIndexValue = 1">
            <a
              [id]="'pills-purchaser_detail'"
              data-bs-toggle="pill"
              (click)="is_notes = false"
              [attr.data-bs-target]="'#purchaser_detail' + eoiTabIndex"
              role="tab"
              [attr.aria-controls]="'purchaser_detail' + eoiTabIndex"
              aria-selected="false">
              <img src="assets/img/user.svg" alt="" class="mr-2" />
              Purchaser Details
            </a>
          </li>
          <li
            class="nav-item cursor-pointer position-relative {{ tabIndexValue === 2 ? 'active' : '' }}"
            role="presentation"
            (click)="tabIndexValue = 2">
            <a
              [id]="'pills-sale_detail'"
              data-bs-toggle="pill"
              (click)="is_notes = false"
              [attr.data-bs-target]="'#sale_detail' + eoiTabIndex"
              role="tab"
              [attr.aria-controls]="'sale_detail' + eoiTabIndex"
              aria-selected="false">
              <img src="assets/img/dashboadIcon/sales.svg" alt="" class="mr-2" />
              Sale Details
            </a>
          </li>
          <ng-container *ngIf="isFileShow">
            <li
              class="nav-item cursor-pointer position-relative {{ tabIndexValue === 3 ? 'active' : '' }}"
              role="presentation"
              (click)="tabIndexValue = 3">
              <a
                [id]="'pills-files'"
                data-bs-toggle="pill"
                (click)="is_notes = false"
                [attr.data-bs-target]="'#files' + eoiTabIndex"
                role="tab"
                [attr.aria-controls]="'files' + eoiTabIndex"
                aria-selected="false">
                <img src="assets/img/dashboadIcon/folder.svg" alt="" class="mr-2" />
                Files
              </a>
            </li>
          </ng-container>
          <!-- <li class="nav-item cursor-pointer position-relative" role="presentation" (click)="tabIndexValue = 3">
            <a class="{{ tabIndexValue === 3 ? 'active' : '' }}" [id]="'pills-agency_detail'" data-bs-toggle="pill"
              (click)="is_notes = false" [attr.data-bs-target]="'#agency_detail' + eoiTabIndex" role="tab"
              [attr.aria-controls]="'agency_detail' + eoiTabIndex" aria-selected="false">
              Agency / Solicitor Detail
            </a>
            <div class="right-boarder" *ngIf="this.selected_EOI"></div>
          </li> -->
          <ng-container *ngIf="this.selected_EOI">
            <li
              class="nav-item cursor-pointer position-relative {{ tabIndexValue === 4 ? 'active' : '' }}"
              role="presentation"
              (click)="tabIndexValue = 4; getEoiLeadList()">
              <a
                [id]="'pills-leads'"
                data-bs-toggle="pill"
                [attr.data-bs-target]="'#leads' + eoiTabIndex"
                role="tab"
                [attr.aria-controls]="'leads' + eoiTabIndex"
                aria-selected="false">
                <img src="assets/img/menuIcon/lead_icon.svg" alt="" class="mr-2" />
                Leads
              </a>
            </li>
          </ng-container>
        </ul>
      </div>
    </ng-template>
    <div class="tab-content" id="pills-tabContent">
      <div
        class="tab-pane fade  {{ tabIndexValue === 0 ? 'show active' : '' }}"
        [id]="'critical_date' + eoiTabIndex"
        role="tabpanel"
        [attr.aria-labelledby]="'pills-critical_date-tab' + eoiTabIndex"
        tabindex="0">
        <ng-container *ngIf="isEOIEdit; else noEOIEdit1">
          <div class="popup-box my-3">
            <div class="row">
              <div class="col-sm-3">
                <p class="f-12 mb-2">Date Received</p>
                <p-calendar [firstDayOfWeek]="1" dateFormat="dd/mm/yy" formControlName="date_received" (onSelect)="selectDate('date_received')">
                </p-calendar>
              </div>
              <div class="col-sm-3">
                <p class="f-12 mb-2">Contract Issued Date</p>
                <p-calendar
                  [firstDayOfWeek]="1"
                  dateFormat="dd/mm/yy"
                  formControlName="contract_issued_date"
                  (onSelect)="selectDate('contract_issued_date')">
                </p-calendar>
              </div>
              <div class="col-sm-3">
                <p class="f-12 mb-2">Contract Due Date</p>
                <p-calendar
                  [firstDayOfWeek]="1"
                  dateFormat="dd/mm/yy"
                  formControlName="contract_due_date"
                  (onSelect)="selectDate('contract_due_date')">
                </p-calendar>
              </div>
              <div class="col-sm-3">
                <p class="f-12 mb-2">Contract Received Date</p>
                <p-calendar
                  [firstDayOfWeek]="1"
                  dateFormat="dd/mm/yy"
                  formControlName="contract_received_date"
                  (onSelect)="selectDate('contract_received_date')">
                </p-calendar>
              </div>
            </div>
          </div>
          <div class="popup-box mb-3">
            <div class="row">
              <div class="col-sm-3">
                <p class="f-12 mb-2">Contract Date</p>
                <p-calendar [firstDayOfWeek]="1" dateFormat="dd/mm/yy" formControlName="contract_date" (onSelect)="selectDate('contract_date')">
                </p-calendar>
              </div>
              <div class="col-sm-3">
                <p class="f-12 mb-2">Cool Off Expiry Date</p>
                <p-calendar
                  [firstDayOfWeek]="1"
                  dateFormat="dd/mm/yy"
                  formControlName="cool_off_expiry_date"
                  (onSelect)="selectDate('cool_off_expiry_date')">
                </p-calendar>
              </div>
              <div class="col-sm-3">
                <p class="f-12 mb-2">Bal. Deposit Due Date</p>
                <p-calendar
                  [firstDayOfWeek]="1"
                  dateFormat="dd/mm/yy"
                  formControlName="bal_deposit_due_date"
                  (onSelect)="selectDate('bal_deposit_due_date')">
                </p-calendar>
              </div>
              <div class="col-sm-3 d-flex align-items-center mt-4">
                <p-checkbox [binary]="true" inputId="binary" class="mr-2" formControlName="balance_deposit_paid"></p-checkbox>
                <p class="f-12 mb-1">Balance Deposit Paid</p>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-3">
                <p class="f-12 mb-2">Finance Due Date</p>
                <p-calendar [firstDayOfWeek]="1" dateFormat="dd/mm/yy" formControlName="finance_due_date" (onSelect)="selectDate('finance_due_date')">
                </p-calendar>
              </div>
              <div class="col-sm-3 d-flex align-items-center mt-4">
                <p-checkbox [binary]="true" inputId="binary" class="mr-2" formControlName="finance_approved"></p-checkbox>
                <p class="f-12 mb-1">Finance Approved</p>
              </div>
              <div class="col-sm-3">
                <p class="f-12 mb-2">FIRB Due Date</p>
                <p-calendar [firstDayOfWeek]="1" dateFormat="dd/mm/yy" formControlName="firb_due_date" (onSelect)="selectDate('firb_due_date')">
                </p-calendar>
              </div>
              <div class="col-sm-3 d-flex align-items-center mt-4">
                <p-checkbox [binary]="true" inputId="binary" class="mr-2" formControlName="firb_approved"></p-checkbox>
                <p class="f-12 mb-1">FIRB Approved</p>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-3">
                <p class="f-12 mb-2">Additional Condition</p>
                <input type="text" formControlName="additional_condition" />
              </div>
              <div class="col-sm-3 d-flex align-items-center mt-4">
                <p-checkbox [binary]="true" inputId="binary" class="mr-2" formControlName="additional_condition_satisfied"></p-checkbox>
                <p class="f-12 mb-1">Additional Condition Satisfied</p>
              </div>
              <div class="col-sm-3">
                <p class="f-12 mb-2">Non YPM Sale</p>
                <ng-select
                  [items]="YpmSales"
                  bindLabel="tag_name"
                  bindValue="tag_slug"
                  [searchable]="true"
                  placeholder="Select"
                  [clearable]="false"
                  formControlName="ypm_sale">
                </ng-select>
              </div>
            </div>
          </div>
          <div class="popup-box mb-3">
            <div class="row">
              <div class="col-sm-2">
                <p class="f-12 mb-2">Unconditional Date</p>
                <p-calendar
                  [firstDayOfWeek]="1"
                  dateFormat="dd/mm/yy"
                  formControlName="unconditional_date"
                  (onSelect)="selectDate('unconditional_date')">
                </p-calendar>
              </div>
              <div class="col-sm-2">
                <p class="f-12 mb-2">Projected Settlement Date</p>
                <p-calendar
                  [firstDayOfWeek]="1"
                  dateFormat="dd/mm/yy"
                  formControlName="projected_settlement_date"
                  (onSelect)="selectDate('projected_settlement_date')">
                </p-calendar>
              </div>
              <div class="col-sm-2 form-group">
                <p class="f-12 mb-2">Settlement Date</p>
                <p-calendar [firstDayOfWeek]="1" dateFormat="dd/mm/yy" formControlName="settlement_date" (onSelect)="selectDate('settlement_date')">
                </p-calendar>
              </div>
              <div class="col-sm-2 form-group">
                <p class="f-12 mb-2">Cancelled Date</p>
                <p-calendar [firstDayOfWeek]="1" dateFormat="dd/mm/yy" formControlName="cancelled_date" (onSelect)="selectDate('cancelled_date')">
                </p-calendar>
              </div>
              <div class="col-sm-2 form-group">
                <p class="f-12 mb-2">Cancelled Reason</p>
                <ng-select
                  [items]="not_further_interest"
                  bindLabel="tag_name"
                  bindValue="tag_name"
                  [searchable]="true"
                  placeholder="Select"
                  [clearable]="false"
                  formControlName="cancelled_reason">
                </ng-select>
              </div>
              <div class="col-sm-2 d-flex align-items-center mt-2">
                <p-checkbox [binary]="true" inputId="binary" class="mr-2" formControlName="cancelled"></p-checkbox>
                <p class="f-12 mb-1">Cancelled</p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-5 pr-0">
              <div class="popup-box mb-3">
                <div class="row">
                  <div class="col-sm-12 position-relative">
                    <p class="f-12 mb-2">Agent Comments</p>
                    <div
                      class="mention-input"
                      contenteditable="true"
                      formControlName="agent_comments"
                      appMention
                      [mentionList]="association_internal_agent"
                      mentionIdsControl="agent_comments_user"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-4 px-3">
              <div class="popup-box">
                <div class="row">
                  <div class="col-sm-12 position-relative">
                    <p class="f-12 mb-2">Admin Only Comments</p>
                    <div
                      class="mention-input"
                      contenteditable="true"
                      formControlName="admin_only_comments"
                      appMention
                      [mentionList]="association_internal_agent"
                      mentionIdsControl="admin_comments_user"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-3 pl-0">
              <div class="popup-box">
                <div class="row">
                  <div class="col-sm-12 position-relative">
                    <p class="f-12 mb-2">Comments</p>
                    <div
                      class="mention-input"
                      contenteditable="true"
                      formControlName="comments"
                      appMention
                      [mentionList]="association_internal_agent"
                      mentionIdsControl="comments_user"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-template #noEOIEdit1>
          <div class="popup-box my-3">
            <div class="d-flex align-items-center gap-3 flex-wrap">
              <div class="d-flex flex-column w-230px">
                <label class="pb-6px f-12 _fw-600" for="lead_category">Date Received</label>
                <p class="text-capitalize _fw-400">{{ EOI_form.controls['date_received'].value | date: 'dd/MM/yy' }}</p>
              </div>
              <div class="d-flex flex-column w-230px">
                <label class="pb-6px f-12 _fw-600" for="lead_category">Contract Issued Date</label>
                <p class="text-capitalize _fw-400">{{ EOI_form.controls['contract_issued_date'].value | date: 'dd/MM/yy' }}</p>
              </div>
              <div class="d-flex flex-column w-230px">
                <label class="pb-6px f-12 _fw-600" for="lead_category">Contract Due Date</label>
                <p class="text-capitalize _fw-400">{{ EOI_form.controls['contract_due_date'].value | date: 'dd/MM/yy' }}</p>
              </div>
              <div class="d-flex flex-column w-230px">
                <label class="pb-6px f-12 _fw-600" for="lead_category">Contract Received Date</label>
                <p class="text-capitalize _fw-400">{{ EOI_form.controls['contract_received_date'].value | date: 'dd/MM/yy' }}</p>
              </div>
              <div class="d-flex flex-column w-230px">
                <label class="pb-6px f-12 _fw-600" for="lead_category">Contract Date</label>
                <p class="text-capitalize _fw-400">{{ EOI_form.controls['contract_date'].value | date: 'dd/MM/yy' }}</p>
              </div>
              <div class="d-flex flex-column w-230px">
                <label class="pb-6px f-12 _fw-600" for="lead_category">Cool Off Expiry Date</label>
                <p class="text-capitalize _fw-400">{{ EOI_form.controls['cool_off_expiry_date'].value | date: 'dd/MM/yy' }}</p>
              </div>
              <div class="d-flex flex-column w-230px">
                <label class="pb-6px f-12 _fw-600" for="lead_category">Bal. Deposit Due Date</label>
                <p class="text-capitalize _fw-400">{{ EOI_form.controls['bal_deposit_due_date'].value | date: 'dd/MM/yy' }}</p>
              </div>
              <div class="d-flex flex-column w-230px">
                <label class="pb-6px f-12 _fw-600" for="lead_category">Balance Deposit Paid</label>
                <p class="text-capitalize _fw-400">{{ EOI_form.controls['balance_deposit_paid'].value == true ? 'Yes' : 'No' }}</p>
              </div>
              <div class="d-flex flex-column w-230px">
                <label class="pb-6px f-12 _fw-600" for="lead_category">Finance Due Date</label>
                <p class="text-capitalize _fw-400">{{ EOI_form.controls['finance_due_date'].value | date: 'dd/MM/yy' }}</p>
              </div>
              <div class="d-flex flex-column w-230px">
                <label class="pb-6px f-12 _fw-600" for="lead_category">Finance Approved</label>
                <p class="text-capitalize _fw-400">{{ EOI_form.controls['finance_approved'].value == true ? 'Yes' : 'No' }}</p>
              </div>
              <div class="d-flex flex-column w-230px">
                <label class="pb-6px f-12 _fw-600" for="lead_category">FIRB Due Date</label>
                <p class="text-capitalize _fw-400">{{ EOI_form.controls['firb_due_date'].value | date: 'dd/MM/yy' }}</p>
              </div>
              <div class="d-flex flex-column w-230px">
                <label class="pb-6px f-12 _fw-600" for="lead_category">FIRB Approved</label>
                <p class="text-capitalize _fw-400">{{ EOI_form.controls['firb_approved'].value == true ? 'Yes' : 'No' }}</p>
              </div>
              <div class="d-flex flex-column w-230px">
                <label class="pb-6px f-12 _fw-600" for="lead_category">Additional Condition</label>
                <p class="text-capitalize _fw-400">{{ EOI_form.controls['additional_condition'].value }}</p>
              </div>
              <div class="d-flex flex-column w-230px">
                <label class="pb-6px f-12 _fw-600" for="lead_category">Additional Condition Satisfied</label>
                <p class="text-capitalize _fw-400">{{ EOI_form.controls['additional_condition_satisfied'].value == true ? 'Yes' : 'No' }}</p>
              </div>
              <div class="d-flex flex-column w-230px">
                <label class="pb-6px f-12 _fw-600" for="lead_category">Non YPM Sale</label>
                <p class="text-capitalize _fw-400">{{ EOI_form.controls['ypm_sale']?.value }}</p>
              </div>
              <div class="d-flex flex-column w-230px">
                <label class="pb-6px f-12 _fw-600" for="lead_category">Unconditional Date</label>
                <p class="text-capitalize _fw-400">{{ EOI_form.controls['unconditional_date'].value | date: 'dd/MM/yy' }}</p>
              </div>
              <div class="d-flex flex-column w-230px">
                <label class="pb-6px f-12 _fw-600" for="lead_category">Projected Settlement Date</label>
                <p class="text-capitalize _fw-400">{{ EOI_form.controls['projected_settlement_date'].value | date: 'dd/MM/yy' }}</p>
              </div>
              <div class="d-flex flex-column w-230px">
                <label class="pb-6px f-12 _fw-600" for="lead_category">Settlement Date</label>
                <p class="text-capitalize _fw-400">{{ EOI_form.controls['settlement_date'].value | date: 'dd/MM/yy' }}</p>
              </div>
              <div class="d-flex flex-column w-230px">
                <label class="pb-6px f-12 _fw-600" for="lead_category">Cancelled Date</label>
                <p class="text-capitalize _fw-400">{{ EOI_form.controls['cancelled_date'].value | date: 'dd/MM/yy' }}</p>
              </div>
              <div class="d-flex flex-column w-230px">
                <label class="pb-6px f-12 _fw-600" for="lead_category">Cancelled Reason</label>
                <p class="text-capitalize _fw-400">{{ EOI_form.controls['cancelled_reason'].value }}</p>
              </div>
              <div class="d-flex flex-column w-230px">
                <label class="pb-6px f-12 _fw-600" for="lead_category">Cancelled</label>
                <p class="text-capitalize _fw-400">{{ EOI_form.controls['cancelled'].value == true ? 'Yes' : 'No' }}</p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-5 pr-0">
              <div class="popup-box mb-3">
                <div class="row">
                  <ng-container *ngIf="isAgentAllow(); else noAgentAllow">
                    <div class="col-sm-12 position-relative">
                      <div class="mb-2 d-flex align-items-center justify-content-between">
                        <p class="f-12">Agent Comments</p>
                        <div class="d-flex align-items-center">
                          <button class="_cancel-btn mx-2 bg-white" (click)="closeEOI()" *ngIf="!isMobile_device">Close</button>
                          <button class="mr-2 _outline-btn bg-white" (click)="saveEOI('onlyCreate')" *ngIf="!isCreateNew">Save</button>
                          <button class="_primary-btn" (click)="saveEOI('create')">Save & Close</button>
                        </div>
                      </div>
                      <div
                        class="mention-input"
                        contenteditable="true"
                        formControlName="agent_comments"
                        appMention
                        [mentionList]="association_internal_agent"
                        mentionIdsControl="agent_comments_user"></div>
                    </div>
                  </ng-container>
                  <ng-template #noAgentAllow>
                    <div class="col-sm-12 position-relative">
                      <p class="f-12 mb-2">Agent Comments</p>
                      <div
                        class="read-mention"
                        formControlName="agent_comments"
                        appMention
                        [mentionList]="association_internal_agent"
                        mentionIdsControl="agent_comments_user"></div>
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
            <div class="col-sm-4 px-3">
              <div class="popup-box">
                <div class="row">
                  <div class="col-sm-12">
                    <p class="f-12 mb-2">Admin Only Comments</p>
                    <div
                      class="read-mention"
                      formControlName="admin_only_comments"
                      appMention
                      [mentionList]="association_internal_agent"
                      mentionIdsControl="admin_comments_user"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-3 pl-0">
              <div class="popup-box">
                <div class="row">
                  <div class="col-sm-12">
                    <p class="f-12 mb-2">Comments</p>
                    <div
                      class="read-mention"
                      formControlName="comments"
                      appMention
                      [mentionList]="association_internal_agent"
                      mentionIdsControl="comments_user"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </div>
      <div
        class="tab-pane fade  {{ tabIndexValue === 1 ? 'show active' : '' }}"
        [id]="'purchaser_detail' + eoiTabIndex"
        role="tabpanel"
        [attr.aria-labelledby]="'pills-purchaser_detail-tab' + eoiTabIndex"
        tabindex="0">
        <ng-container *ngIf="isEOIEdit; else noEOIEdit2">
          <div class="popup-box my-3">
            <div class="row">
              <div class="col-sm-4">
                <p class="f-12 mb-2">Purchaser 1</p>
                <label for="" style="width: 100%">
                  <re-multiselect
                    [module]="'contacts'"
                    [placeholder]="'Select Contact'"
                    [truncate]="55"
                    [isMultiple]="false"
                    [isFullObject]="true"
                    [isCreateNew]="true"
                    (createNew)="openRightModal($event)"
                    [isEmail]="true"
                    [selected_ids]="EOI_form.controls['purchaser_1'].value"
                    (onUpdate)="onUpdateMSelect($event, 'purchaser_1')"
                    (editRecord)="editContact($event)"
                    [style]="{ width: '100%' }">
                  </re-multiselect>
                </label>
              </div>
              <div class="col-sm-3">
                <p class="f-12 mb-2">Nationality Purchaser 1</p>
                <input type="text" formControlName="nationality_purchaser_1" />
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-4">
                <p class="f-12 mb-2">Purchaser 2</p>
                <label for="" style="width: 100%">
                  <re-multiselect
                    [module]="'contacts'"
                    [placeholder]="'Select Contact'"
                    [truncate]="55"
                    [isMultiple]="false"
                    [isEmail]="true"
                    [isCreateNew]="true"
                    (createNew)="openRightModal($event)"
                    [selected_ids]="EOI_form.controls['purchaser_2'].value"
                    [isFullObject]="true"
                    (onUpdate)="onUpdateMSelect($event, 'purchaser_2')"
                    (editRecord)="editContact($event)"
                    [style]="{ width: '100%' }"></re-multiselect>
                </label>
              </div>
              <div class="col-sm-3">
                <p class="f-12 mb-2">Nationality Purchaser 2</p>
                <input type="text" formControlName="nationality_purchaser_2" />
              </div>
              <div class="col-sm-4 mt-4">
                <button (click)="addPurchaser()" class="_view-btn p-2 h-auto" pTooltip="Add Additional Purchaser" tooltipPosition="top">
                  <i class="pi pi-plus f-12"></i>
                </button>
              </div>
            </div>
            <ng-container *ngIf="purchaser_list?.length > 0">
              <div class="row mt-2" *ngFor="let item of purchaser_list; let i = index">
                <div class="col-sm-4">
                  <p class="f-12 mb-2">Purchaser {{ i + 3 }}</p>
                  <label for="" style="width: 100%">
                    <re-multiselect
                      [module]="'contacts'"
                      [placeholder]="'Select'"
                      [truncate]="25"
                      [isMultiple]="false"
                      [selected_ids]="item.purchaser"
                      [isEmail]="true"
                      (onUpdate)="onUpdateOtherPurchaser($event, i)"
                      [style]="{ width: '100%' }"
                      (editRecord)="editContact($event)"></re-multiselect>
                  </label>
                </div>
                <div class="col-sm-3">
                  <p class="f-12 mb-2">Nationality Purchaser {{ i + 3 }}</p>
                  <input type="text" [(ngModel)]="item.nationality" [ngModelOptions]="{ standalone: true }" />
                </div>
                <div class="col-sm-4 mt-4">
                  <button (click)="removePurchaser(i)" class="_view-btn p-2 h-auto"><i class="pi pi-times f-12"></i></button>
                </div>
              </div>
            </ng-container>
          </div>
          <div class="popup-box">
            <div class="row">
              <div class="col-sm-4">
                <p class="f-12 mb-2">FIRB</p>
                <ng-select
                  [items]="firb"
                  bindLabel="name"
                  bindValue="val"
                  [searchable]="true"
                  placeholder="Select"
                  [clearable]="true"
                  formControlName="firb">
                </ng-select>
              </div>
              <div class="col-sm-4">
                <p class="f-12 mb-2">Purchase Type</p>
                <ng-select
                  [items]="purchase_type"
                  bindLabel="tag_name"
                  bindValue="tag_name"
                  [searchable]="true"
                  placeholder="Select"
                  [clearable]="true"
                  formControlName="purchase_type">
                </ng-select>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-template #noEOIEdit2>
          <div class="popup-box my-3">
            <div class="d-flex align-items-center gap-3 flex-wrap">
              <div class="d-flex flex-column w-230px">
                <label class="pb-6px f-12 _fw-600" for="lead_category">Purchaser 1</label>
                <p class="text-capitalize cursor-pointer" (click)="editContact(selected_EOI, 'purchaser_1')">{{ selected_EOI?.purchaser_1_name }}</p>
              </div>
              <div class="d-flex flex-column w-230px">
                <label class="pb-6px f-12 _fw-600" for="lead_category">Nationality Purchaser 1</label>
                <p class="text-capitalize _fw-400">{{ EOI_form.controls['nationality_purchaser_1'].value }}</p>
              </div>
              <div class="d-flex flex-column w-230px">
                <label class="pb-6px f-12 _fw-600" for="lead_category">Purchaser 2</label>
                <p class="text-capitalize cursor-pointer" (click)="editContact(selected_EOI, 'purchaser_2')">{{ selected_EOI?.purchaser_2_name }}</p>
              </div>
              <div class="d-flex flex-column w-230px">
                <label class="pb-6px f-12 _fw-600" for="lead_category">Nationality Purchaser 2</label>
                <p class="text-capitalize _fw-400">{{ EOI_form.controls['nationality_purchaser_2'].value }}</p>
              </div>
              <div class="d-flex flex-column w-230px">
                <label class="pb-6px f-12 _fw-600" for="lead_category">FIRB</label>
                <p class="text-capitalize _fw-400">{{ EOI_form.controls['firb'].value }}</p>
              </div>
              <div class="d-flex flex-column w-230px">
                <label class="pb-6px f-12 _fw-600" for="lead_category">Purchase Type</label>
                <p class="text-capitalize _fw-400">{{ EOI_form.controls['purchase_type'].value }}</p>
              </div>
            </div>
          </div>
          <ng-container *ngIf="purchaser_list?.length > 0">
            <div class="popup-box mb-3">
              <div class="d-flex align-items-center gap-3 flex-wrap">
                <ng-container *ngFor="let item of purchaser_list; let i = index">
                  <div class="d-flex flex-column w-230px">
                    <label class="pb-6px f-12 _fw-600" for="lead_category">Purchaser {{ i + 3 }}</label>
                    <p class="text-capitalize _fw-400">{{ item.purchaser_name }}</p>
                  </div>
                  <div class="d-flex flex-column w-230px">
                    <label class="pb-6px f-12 _fw-600" for="lead_category">Nationality Purchaser {{ i + 3 }}</label>
                    <p class="text-capitalize _fw-400">{{ item.nationality }}</p>
                  </div>
                </ng-container>
              </div>
            </div>
          </ng-container>
        </ng-template>
      </div>
      <div
        class="tab-pane fade  {{ tabIndexValue === 2 ? 'show active' : '' }}"
        [id]="'sale_detail' + eoiTabIndex"
        role="tabpanel"
        [attr.aria-labelledby]="'pills-sale_detail-tab' + eoiTabIndex"
        tabindex="0">
        <ng-container *ngIf="isEOIEdit; else noEOIEdit3">
          <div class="popup-box my-3">
            <div class="row">
              <div class="col-sm-3">
                <p class="f-12 mb-2">Contract Price</p>
                <app-price-input [field_value]="EOI_form.controls['contract_price'].value" (onUpdate)="updatePrice($event, 'contract_price')">
                </app-price-input>
              </div>
              <div class="col-sm-3">
                <p class="f-12 mb-2">Total Deposit</p>
                <app-price-input [field_value]="EOI_form.controls['total_deposit'].value" (onUpdate)="updatePrice($event, 'total_deposit')">
                </app-price-input>
              </div>
              <div class="col-sm-3">
                <p class="f-12 mb-2">Initial Deposit</p>
                <app-price-input [field_value]="EOI_form.controls['initial_deposit'].value" (onUpdate)="updatePrice($event, 'initial_deposit')">
                </app-price-input>
              </div>
              <div class="col-sm-3">
                <p class="f-12 mb-2">Balance of Deposit</p>
                <app-price-input [field_value]="EOI_form.controls['balance_of_deposit'].value" (onUpdate)="updatePrice($event, 'balance_of_deposit')">
                </app-price-input>
              </div>
            </div>
          </div>
          <div class="popup-box mb-3">
            <div class="row mt-2">
              <div class="col-sm-2">
                <p class="f-12 mb-2">Car No. Included</p>
                <ng-select
                  class="ng-site-input"
                  formControlName="carpark_included"
                  [items]="car_park_list"
                  [multiple]="true"
                  bindLabel="carpark_lot"
                  bindValue="carpark_lot"
                  [searchable]="true"
                  placeholder="Select"
                  [clearable]="false"
                  (change)="changeCarStorage($event, 'car_park_include')">
                  <ng-template ng-label-tmp let-item="item">
                    <div class="d-flex align-items-center cursor-pointer px-1">
                      <i
                        class="pi pi-times-circle cursor-pointer"
                        (click)="clearCarParkStorage(item?.carpark_lot, 'carpark_included'); $event.stopPropagation()"></i>
                      <p class="ml-2 ng-value-label">{{ item.carpark_lot }}</p>
                    </div>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item">
                    <span>{{ item.carpark_lot }}</span>
                  </ng-template>
                </ng-select>
              </div>
              <div class="col-sm-2">
                <p class="f-12 mb-2">Car No.</p>
                <ng-select
                  class="ng-site-input"
                  formControlName="carpark_added"
                  [items]="car_park_list"
                  [multiple]="true"
                  bindLabel="carpark_lot"
                  bindValue="carpark_lot"
                  [searchable]="true"
                  placeholder="{{ checkValue(selected_EOI) }}"
                  [clearable]="false"
                  (change)="changeCarStorage($event, 'car_park')">
                  <ng-template ng-label-tmp let-item="item">
                    <div class="d-flex align-items-center cursor-pointer px-1">
                      <i
                        class="pi pi-times-circle cursor-pointer"
                        (click)="clearCarParkStorage(item?.carpark_lot, 'carpark_added'); $event.stopPropagation()"></i>
                      <p class="ml-2 ng-value-label">{{ item.carpark_lot }}</p>
                    </div>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item">
                    <span>{{ item.carpark_lot }}</span>
                  </ng-template>
                </ng-select>
              </div>
              <div class="col-sm-2 form-group">
                <p class="f-12 mb-2">Carpark Price</p>
                <app-price-input [field_value]="EOI_form.controls['carpark_price'].value" (onUpdate)="updatePrice($event, 'carpark_price')">
                </app-price-input>
              </div>
              <div class="col-sm-2">
                <p class="f-12 mb-2">Storage Included</p>
                <ng-select
                  class="ng-site-input"
                  formControlName="storage_included"
                  [items]="storage_list"
                  [multiple]="true"
                  bindLabel="storage_no"
                  bindValue="storage_no"
                  [searchable]="true"
                  placeholder="Select"
                  [clearable]="false"
                  (change)="changeCarStorage($event, 'storage_include')">
                  <ng-template ng-label-tmp let-item="item">
                    <div class="d-flex align-items-center cursor-pointer px-1">
                      <i
                        class="pi pi-times-circle cursor-pointer"
                        (click)="clearCarParkStorage(item?.storage_no, 'storage_included'); $event.stopPropagation()"></i>
                      <p class="ml-2 ng-value-label">{{ item.storage_no }}</p>
                    </div>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item">
                    <span>{{ item.storage_no }}</span>
                  </ng-template>
                </ng-select>
              </div>
              <div class="col-sm-2">
                <p class="f-12 mb-2">Storage</p>
                <ng-select
                  class="ng-site-input"
                  formControlName="storage_added"
                  [items]="storage_list"
                  [multiple]="true"
                  bindLabel="storage_no"
                  bindValue="storage_no"
                  [searchable]="true"
                  placeholder="Select"
                  [clearable]="false"
                  (change)="changeCarStorage($event, 'storage')">
                  <ng-template ng-label-tmp let-item="item">
                    <div class="d-flex align-items-center cursor-pointer px-1">
                      <i
                        class="pi pi-times-circle cursor-pointer"
                        (click)="clearCarParkStorage(item?.storage_no, 'storage_added'); $event.stopPropagation()"></i>
                      <p class="ml-2 ng-value-label">{{ item.storage_no }}</p>
                    </div>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item">
                    <span>{{ item.storage_no }}</span>
                  </ng-template>
                </ng-select>
              </div>
              <div class="col-sm-2 form-group">
                <p class="f-12 mb-2">Storage Price</p>
                <app-price-input [field_value]="EOI_form.controls['storage_price'].value" (onUpdate)="updatePrice($event, 'storage_price')">
                </app-price-input>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-4">
                <p class="f-12 mb-2">Deductible Incentives</p>
                <input type="text" formControlName="deductible_incentives" />
              </div>
              <div class="col-sm-4">
                <p class="f-12 mb-2">Deductible Incentives Price</p>
                <app-price-input
                  [field_value]="EOI_form.controls['deductible_incentives_price'].value"
                  (onUpdate)="updatePrice($event, 'deductible_incentives_price')">
                </app-price-input>
              </div>
              <div class="col-sm-4">
                <p class="f-12 mb-2">Subtotal</p>
                <app-price-input [field_value]="EOI_form.controls['subtotal'].value" (onUpdate)="updatePrice($event, 'subtotal')"> </app-price-input>
              </div>
            </div>
            <div class="row">
              <div class="col-md-9 mt-3">
                <ng-container *ngFor="let upgrade of upgrades; let i = index">
                  <div class="row mb-2">
                    <div class="col-sm-4">
                      <p class="f-12 mb-2">Upgrade Group</p>
                      <ng-select
                        [items]="lmService?.ProjectDetail?.project_upgrades"
                        bindLabel="name"
                        (change)="changeGroup($event, i, item)"
                        [searchable]="true"
                        placeholder="Select"
                        [clearable]="true"
                        [ngModelOptions]="{ standalone: true }"
                        [(ngModel)]="upgrade.upgrade_group_1_price">
                      </ng-select>
                    </div>
                    <div class="col-sm-4">
                      <p class="f-12 mb-2">Upgrade Type</p>
                      <ng-select
                        [items]="upgradeGroupList[i]"
                        bindLabel="upgrade"
                        [ngModelOptions]="{ standalone: true }"
                        (change)="changeGroupPrice($event, i)"
                        [searchable]="true"
                        placeholder="Select"
                        [(ngModel)]="upgrade.upgrade_group_1"
                        [multiple]="true"
                        [clearable]="true">
                      </ng-select>
                    </div>
                    <div class="col-sm-3">
                      <p class="f-12 mb-2">Upgrades Total</p>
                      <app-price-input [field_value]="upgrade.upgrades_total" (onUpdate)="updatePrice($event, 'upgrades_total', i)">
                      </app-price-input>
                    </div>
                    <div class="col-sm-1 icon">
                      <i
                        class="group-icon-position mt-2 ml-2 pi pi-plus-circle cursor-pointer"
                        (click)="
                          upgrades.push({
                            upgrade_group_1: null,
                            upgrade_group_1_price: null,
                            upgrades_total: null,
                          })
                        "></i>
                      <i class="group-icon-position mt-2 ml-2 pi pi-times-circle cursor-pointer" *ngIf="i !== 0" (click)="upgrades.splice(i, 1)"></i>
                    </div>
                  </div>
                </ng-container>
              </div>
              <div class="col-sm-3 mt-3">
                <p class="f-12 mb-2">Total Price</p>
                <app-price-input [field_value]="EOI_form.controls['total_price'].value" (onUpdate)="updatePrice($event, 'total_price')">
                </app-price-input>
              </div>
            </div>
            <button (click)="showOther()" class="other-upgrade">Other</button>
            <div class="row" *ngIf="isOtherUpgrade">
              <div class="col-sm-3">
                <p class="f-12 mb-2">Upgrade Group</p>
                <input type="text" [ngModelOptions]="{ standalone: true }" [(ngModel)]="otherUpgrade.other_upgrade_group" />
              </div>
              <div class="col-sm-3">
                <p class="f-12 mb-2">Upgrade Type</p>
                <input type="text" [ngModelOptions]="{ standalone: true }" [(ngModel)]="otherUpgrade.other_upgrade_type" />
              </div>
              <div class="col-sm-2">
                <p class="f-12 mb-2">Price</p>
                <app-price-input [field_value]="otherUpgrade.other_upgrade_price" (onUpdate)="updatePrice($event, 'other_upgrade_price')">
                </app-price-input>
              </div>
            </div>
          </div>
          <div class="popup-box mb-3">
            <div class="row">
              <div class="col-sm-3 mt-2">
                <p class="f-12 mb-2">Bonus Campaign</p>
                <ng-select
                  [items]="lmService?.ProjectDetail?.bonus_campaign"
                  [searchable]="true"
                  placeholder="Select"
                  [clearable]="true"
                  formControlName="bonus_campaign">
                </ng-select>
              </div>
              <div class="col-sm-2 mt-2">
                <p class="f-12 mb-2">Bonus ($)</p>
                <app-price-input [field_value]="EOI_form.controls['bonus'].value" (onUpdate)="updatePrice($event, 'bonus_form')"> </app-price-input>
              </div>
              <div class="col-sm-3 mt-2">
                <p class="f-12 mb-2">Bonus Payable Upon</p>
                <ng-select
                  [items]="lmService?.ProjectDetail?.bonus_payable_upon"
                  [searchable]="true"
                  placeholder="Select"
                  [clearable]="true"
                  formControlName="bonus_payable_upon">
                </ng-select>
              </div>
              <div class="col-sm-3 mt-2">
                <p class="f-12 mb-2">Bonus Payable To</p>
                <ng-select
                  [items]="lmService?.ProjectDetail?.bonus_payable_to"
                  [searchable]="true"
                  placeholder="Select"
                  [clearable]="true"
                  formControlName="bonus_payable_to">
                </ng-select>
              </div>
              <div class="col-sm-1 icon mt-2">
                <i
                  class="group-icon-position mt-2 ml-2 pi pi-plus-circle cursor-pointer"
                  (click)="
                    bonuses.push({
                      campaign: null,
                      bonus: null,
                      payableUpon: null,
                      payableTo: null,
                    })
                  "></i>
              </div>
            </div>
            <div class="row">
              <ng-container *ngFor="let item of bonuses; let i = index">
                <div class="col-sm-3 mt-2">
                  <p class="f-12 mb-2">Bonus Campaign</p>
                  <ng-select
                    [items]="lmService?.ProjectDetail?.bonus_campaign"
                    [searchable]="true"
                    placeholder="Select"
                    [ngModelOptions]="{ standalone: true }"
                    [clearable]="true"
                    [(ngModel)]="item.campaign">
                  </ng-select>
                </div>
                <div class="col-sm-2 mt-2">
                  <p class="f-12 mb-2">Bonus ($)</p>
                  <app-price-input [field_value]="item.bonus" (onUpdate)="updatePrice($event, 'bonus', i)"> </app-price-input>
                </div>
                <div class="col-sm-3 mt-2">
                  <p class="f-12 mb-2">Bonus Payable Upon</p>
                  <ng-select
                    [items]="lmService?.ProjectDetail?.bonus_payable_upon"
                    [searchable]="true"
                    [ngModelOptions]="{ standalone: true }"
                    placeholder="Select"
                    [clearable]="true"
                    [(ngModel)]="item.payableUpon">
                  </ng-select>
                </div>
                <div class="col-sm-3 mt-2">
                  <p class="f-12 mb-2">Bonus Payable To</p>
                  <ng-select
                    [items]="lmService?.ProjectDetail?.bonus_payable_to"
                    [searchable]="true"
                    placeholder="Select"
                    [clearable]="true"
                    [ngModelOptions]="{ standalone: true }"
                    [(ngModel)]="item.payableTo">
                  </ng-select>
                </div>
                <div class="col-sm-1 icon mt-2">
                  <i
                    class="group-icon-position mt-2 ml-2 pi pi-plus-circle cursor-pointer"
                    (click)="
                      bonuses.push({
                        campaign: null,
                        bonus: null,
                        payableUpon: null,
                        payableTo: null,
                      })
                    "></i>

                  <i class="group-icon-position mt-2 ml-2 pi pi-times-circle cursor-pointer" (click)="bonuses.splice(i, 1)"></i>
                </div>
              </ng-container>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6 pr-0">
              <div class="popup-box mb-3">
                <div class="row">
                  <p class="f-12 mb-2">Deposit Comments</p>
                  <textarea name="note" spellcheck="true" class="text-area-style" formControlName="deposit_comments"> </textarea>
                </div>
              </div>
            </div>
            <div class="col-sm-6 pl-3">
              <div class="popup-box">
                <div class="row">
                  <div class="col-sm-12">
                    <p class="f-12 mb-2">Bonus Comments</p>
                    <textarea name="note" spellcheck="true" class="text-area-style" formControlName="bonus_comments"> </textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 pr-0">
              <div class="popup-box mb-3">
                <p class="f-14 mb-2">Agency</p>
                <div class="row">
                  <div class="col-sm-4">
                    <p class="f-12 mb-2">Agency</p>
                    <ng-select
                      class="project-link"
                      formControlName="agency"
                      [items]="externalAgency"
                      [virtualScroll]="true"
                      [bufferAmount]="10"
                      [multiple]="false"
                      bindLabel="full_name"
                      bindValue="_id"
                      [searchable]="true"
                      placeholder="Select"
                      [clearable]="true"
                      (change)="solicitorContact()"
                      [ngClass]="{ '_input-error': !externalAgency?.length && EOI_form.controls['agency'].value }">
                      <ng-template ng-label-tmp let-item="item">
                        <div class="d-flex align-items-center cursor-pointer">
                          <i class="pi pi-times-circle cursor-pointer" (click)="clear(item?._id, 'agency'); $event.stopPropagation()"></i>
                          <p class="ml-2 ng-value-label" (click)="openModal(item, 'contact')">
                            {{ item.full_name }}
                          </p>
                        </div>
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item">
                        <span>{{ item.full_name }}</span>
                      </ng-template>
                    </ng-select>
                  </div>
                  <div class="col-sm-4">
                    <p class="f-12 mb-2">Agent</p>
                    <ng-select
                      class="project-link"
                      formControlName="agent"
                      [items]="agency_contact"
                      [virtualScroll]="true"
                      [bufferAmount]="10"
                      [multiple]="false"
                      bindLabel="full_name"
                      bindValue="_id"
                      [searchable]="true"
                      placeholder="Select"
                      [clearable]="true"
                      [ngClass]="{ '_input-error': !agency_contact?.length && EOI_form.controls['agent'].value }">
                      <ng-template ng-label-tmp let-item="item">
                        <div class="d-flex align-items-center cursor-pointer">
                          <p class="ml-2 ng-value-label" (click)="openModal(item, 'contact')">
                            {{ item.full_name }}
                          </p>
                        </div>
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item">
                        <span>{{ item.full_name }}</span>
                      </ng-template>
                    </ng-select>
                  </div>
                  <div class="col-sm-4">
                    <p class="f-12 mb-2">Reservation Code</p>
                    <input type="text" formControlName="reservation_code" />
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-sm-4">
                    <p class="f-12 mb-2">Team</p>
                    <ng-select
                      [items]="internal_team"
                      bindLabel="name"
                      bindValue="_id"
                      (change)="getTeamUser(false)"
                      [searchable]="true"
                      placeholder="Select"
                      [clearable]="true"
                      formControlName="internal_team">
                    </ng-select>
                  </div>
                  <div class="col-sm-4">
                    <p class="f-12 mb-2">Internal Agent 1</p>
                    <ng-select
                      class="project-link"
                      formControlName="internal_agent"
                      [items]="internal_agent"
                      [virtualScroll]="true"
                      [bufferAmount]="10"
                      [multiple]="false"
                      bindLabel="name"
                      bindValue="_id"
                      [searchable]="true"
                      placeholder="Select"
                      [clearable]="true"
                      [ngClass]="{ '_input-error': !internal_agent?.length && EOI_form.controls['internal_agent'].value }">
                      <ng-template ng-label-tmp let-item="item">
                        <div class="d-flex align-items-center cursor-pointer">
                          <p class="ng-value-label" (click)="openModal(item, 'internal')">
                            {{ item.name }}
                          </p>
                        </div>
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item">
                        <span>{{ item.name }}</span>
                      </ng-template>
                    </ng-select>
                  </div>
                  <div class="col-sm-4">
                    <p class="f-12 mb-2">Internal Agent 2</p>
                    <ng-select
                      class="project-link"
                      formControlName="internal_agent_2"
                      [items]="internal_agent"
                      [virtualScroll]="true"
                      [bufferAmount]="10"
                      [multiple]="false"
                      bindLabel="name"
                      bindValue="_id"
                      [searchable]="true"
                      placeholder="Select"
                      [clearable]="true"
                      [ngClass]="{ '_input-error': !internal_agent?.length && EOI_form.controls['internal_agent_2'].value }">
                      <ng-template ng-label-tmp let-item="item">
                        <div class="d-flex align-items-center cursor-pointer">
                          <i class="pi pi-times-circle cursor-pointer" (click)="clear(item?._id, 'internal_agent_2'); $event.stopPropagation()"></i>
                          <p class="ml-2 ng-value-label" (click)="openModal(item, 'internal')">
                            {{ item.name }}
                          </p>
                        </div>
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item">
                        <span>{{ item.name }}</span>
                      </ng-template>
                    </ng-select>
                  </div>
                  <div class="col-sm-4 mt-2">
                    <p class="f-12 mb-2">Internal Agent 3</p>
                    <ng-select
                      class="project-link"
                      formControlName="internal_agent_3"
                      [items]="internal_agent"
                      [virtualScroll]="true"
                      [bufferAmount]="10"
                      [multiple]="false"
                      bindLabel="name"
                      bindValue="_id"
                      [searchable]="true"
                      placeholder="Select"
                      [clearable]="true"
                      [ngClass]="{ '_input-error': !internal_agent?.length && EOI_form.controls['internal_agent_3'].value }">
                      <ng-template ng-label-tmp let-item="item">
                        <div class="d-flex align-items-center cursor-pointer">
                          <i class="pi pi-times-circle cursor-pointer" (click)="clear(item?._id, 'internal_agent_3'); $event.stopPropagation()"></i>
                          <p class="ml-2 ng-value-label" (click)="openModal(item, 'internal')">
                            {{ item.name }}
                          </p>
                        </div>
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item">
                        <span>{{ item.name }}</span>
                      </ng-template>
                    </ng-select>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6 pl-3">
              <div class="popup-box mb-3" style="height: 174px">
                <p class="f-14 mb-2">Solicitor</p>
                <div class="row">
                  <div class="col-sm-6 form-group">
                    <p class="f-12 mb-2">Firm</p>
                    <ng-select
                      [items]="agencyList"
                      bindLabel="full_name"
                      bindValue="full_name"
                      [searchable]="true"
                      placeholder="Select"
                      [clearable]="true"
                      formControlName="firm"
                      (change)="solicitorContact()">
                      <ng-template ng-header-tmp>
                        <p class="cursor-pointer d-flex align-items-center mb-0" (click)="openRightModal()">
                          <i class="pi pi-plus f-12 mr-1"></i> Create new
                        </p>
                      </ng-template>
                    </ng-select>
                  </div>
                  <div class="col-sm-6 form-group">
                    <p class="f-12 mb-2">Solicitor Name</p>
                    <ng-select
                      [items]="solicitor_contact"
                      bindLabel="full_name"
                      bindValue="full_name"
                      [searchable]="true"
                      placeholder="Select"
                      [clearable]="true"
                      formControlName="solicitor_name">
                      <ng-template ng-header-tmp>
                        <p class="cursor-pointer d-flex align-items-center mb-0" (click)="openRightModal()">
                          <i class="pi pi-plus f-12 mr-1"></i> Create new
                        </p>
                      </ng-template>
                    </ng-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6 pr-0">
              <div class="popup-box mb-3">
                <div class="row">
                  <div class="col-sm-12">
                    <p class="f-12 mb-2">Sales Related Notes</p>
                    <textarea name="note" spellcheck="true" class="text-area-style" formControlName="sales_related_notes"> </textarea>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-6 pl-3">
              <div class="popup-box" *ngIf="userRole?.toLowerCase() == 'master admin' || userRole?.toLowerCase() == 'operations manager'">
                <div class="row">
                  <div class="col-sm-12">
                    <p class="f-12 mb-2">Commission Comments <i class="pi pi-lock f-10 ml-1"></i></p>
                    <textarea name="note" spellcheck="true" class="text-area-style" formControlName="commission_comments"> </textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-template #noEOIEdit3>
          <div class="popup-box my-3">
            <div class="d-flex align-items-center gap-3 flex-wrap">
              <div class="d-flex flex-column w-230px">
                <label class="pb-6px f-12 _fw-600" for="lead_category">Contract Price</label>
                <p class="text-capitalize _fw-400">{{ EOI_form.controls['contract_price'].value | currency: 'USD' : 'symbol' : '1.0-0' }}</p>
              </div>
              <div class="d-flex flex-column w-230px">
                <label class="pb-6px f-12 _fw-600" for="lead_category">Total Deposit</label>
                <p class="text-capitalize _fw-400">{{ EOI_form.controls['total_deposit'].value | currency: 'USD' : 'symbol' : '1.0-0' }}</p>
              </div>
              <div class="d-flex flex-column w-230px">
                <label class="pb-6px f-12 _fw-600" for="lead_category">Initial Deposit</label>
                <p class="text-capitalize _fw-400">{{ EOI_form.controls['initial_deposit'].value | currency: 'USD' : 'symbol' : '1.0-0' }}</p>
              </div>
              <div class="d-flex flex-column w-230px">
                <label class="pb-6px f-12 _fw-600" for="lead_category">Balance of Deposit</label>
                <p class="text-capitalize _fw-400">{{ EOI_form.controls['balance_of_deposit'].value | currency: 'USD' : 'symbol' : '1.0-0' }}</p>
              </div>

              <div class="d-flex flex-column w-230px">
                <label class="pb-6px f-12 _fw-600" for="lead_category">Car No. Included</label>
                <p class="text-capitalize _fw-400">{{ EOI_form.controls['carpark_included'].value }}</p>
              </div>
              <div class="d-flex flex-column w-230px">
                <label class="pb-6px f-12 _fw-600" for="lead_category">Car No.</label>
                <p class="text-capitalize _fw-400">{{ EOI_form.controls['carpark_added'].value }}</p>
              </div>
              <div class="d-flex flex-column w-230px">
                <label class="pb-6px f-12 _fw-600" for="lead_category">Carpark Price</label>
                <p class="text-capitalize _fw-400">{{ EOI_form.controls['carpark_price'].value | currency: 'USD' : 'symbol' : '1.0-0' }}</p>
              </div>
              <div class="d-flex flex-column w-230px">
                <label class="pb-6px f-12 _fw-600" for="lead_category">Storage Included</label>
                <p class="text-capitalize _fw-400">{{ EOI_form.controls['storage_included'].value }}</p>
              </div>

              <div class="d-flex flex-column w-230px">
                <label class="pb-6px f-12 _fw-600" for="lead_category">Storage</label>
                <p class="text-capitalize _fw-400">{{ EOI_form.controls['storage_added'].value }}</p>
              </div>
              <div class="d-flex flex-column w-230px">
                <label class="pb-6px f-12 _fw-600" for="lead_category">Storage Price</label>
                <p class="text-capitalize _fw-400">{{ EOI_form.controls['storage_price'].value | currency: 'USD' : 'symbol' : '1.0-0' }}</p>
              </div>
              <div class="d-flex flex-column w-230px">
                <label class="pb-6px f-12 _fw-600" for="lead_category">Deductible Incentives</label>
                <p class="text-capitalize _fw-400">{{ EOI_form.controls['deductible_incentives'].value }}</p>
              </div>
              <div class="d-flex flex-column w-230px">
                <label class="pb-6px f-12 _fw-600" for="lead_category">Deductible Incentives Price</label>
                <p class="text-capitalize _fw-400">
                  {{ EOI_form.controls['deductible_incentives_price'].value | currency: 'USD' : 'symbol' : '1.0-0' }}
                </p>
              </div>
              <div class="d-flex flex-column w-230px">
                <label class="pb-6px f-12 _fw-600" for="lead_category">Subtotal</label>
                <p class="text-capitalize _fw-400">{{ EOI_form.controls['subtotal'].value | currency: 'USD' : 'symbol' : '1.0-0' }}</p>
              </div>
              <div class="d-flex flex-column w-230px">
                <label class="pb-6px f-12 _fw-600" for="lead_category">Total Price</label>
                <p class="text-capitalize _fw-400">{{ EOI_form.controls['total_price'].value | currency: 'USD' : 'symbol' : '1.0-0' }}</p>
              </div>
              <div class="d-flex flex-column w-230px">
                <label class="pb-6px f-12 _fw-600" for="lead_category">Upgrade Group</label>
                <p class="text-capitalize _fw-400">{{ otherUpgrade.other_upgrade_group }}</p>
              </div>
              <div class="d-flex flex-column w-230px">
                <label class="pb-6px f-12 _fw-600" for="lead_category">Upgrade Type</label>
                <p class="text-capitalize _fw-400">{{ otherUpgrade.other_upgrade_type }}</p>
              </div>
              <div class="d-flex flex-column w-230px">
                <label class="pb-6px f-12 _fw-600" for="lead_category">Price ($)</label>
                <p class="text-capitalize _fw-400">{{ otherUpgrade.other_upgrade_price | currency: 'USD' : 'symbol' : '1.0-0' }}</p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6 pr-0">
              <div class="popup-box mb-3">
                <div class="row">
                  <div class="col-sm-12">
                    <label class="pb-6px f-12 _fw-600" for="lead_category">Deposit Comments</label>
                    <p class="text-capitalize _fw-400">{{ EOI_form.controls['deposit_comments'].value }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-6 pl-3">
              <div class="popup-box">
                <div class="row">
                  <div class="col-sm-12">
                    <label class="pb-6px f-12 _fw-600" for="lead_category">Bonus Comments</label>
                    <p class="text-capitalize _fw-400">{{ EOI_form.controls['bonus_comments'].value }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="popup-box mb-3">
            <div class="d-flex align-items-center gap-3 flex-wrap">
              <div class="d-flex flex-column w-230px">
                <label class="pb-6px f-12 _fw-600" for="lead_category">Agency</label>
                <p class="text-capitalize _fw-400">{{ selected_EOI?.agency_name }}</p>
              </div>
              <div class="d-flex flex-column w-230px">
                <label class="pb-6px f-12 _fw-600" for="lead_category">Agent</label>
                <p class="text-capitalize _fw-400">{{ selected_EOI?.agent_name }}</p>
              </div>
              <div class="d-flex flex-column w-230px">
                <label class="pb-6px f-12 _fw-600" for="lead_category">Reservation Code</label>
                <p class="text-capitalize _fw-400">{{ EOI_form.controls['reservation_code'].value }}</p>
              </div>
              <div class="d-flex flex-column w-230px">
                <label class="pb-6px f-12 _fw-600" for="lead_category">Team</label>
                <p class="text-capitalize _fw-400">{{ selected_EOI?.internal_team_name }}</p>
              </div>

              <div class="d-flex flex-column w-230px">
                <label class="pb-6px f-12 _fw-600" for="lead_category">Internal Agent 1</label>
                <p class="text-capitalize _fw-400">{{ selected_EOI?.internal_agent_name }}</p>
              </div>
              <div class="d-flex flex-column w-230px">
                <label class="pb-6px f-12 _fw-600" for="lead_category">Internal Agent 2</label>
                <p class="text-capitalize _fw-400">{{ selected_EOI?.internal_agent_2_name }}</p>
              </div>
              <div class="d-flex flex-column w-230px">
                <label class="pb-6px f-12 _fw-600" for="lead_category">Internal Agent 3</label>
                <p class="text-capitalize _fw-400">{{ selected_EOI?.internal_agent_3_name }}</p>
              </div>
              <div class="d-flex flex-column w-230px">
                <label class="pb-6px f-12 _fw-600" for="lead_category">Firm</label>
                <p class="text-capitalize _fw-400">{{ selected_EOI?.firm }}</p>
              </div>
              <div class="d-flex flex-column w-230px">
                <label class="pb-6px f-12 _fw-600" for="lead_category">Solicitor Name</label>
                <p class="text-capitalize _fw-400">{{ selected_EOI?.solicitor_name }}</p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6 pr-0">
              <div class="popup-box mb-3">
                <div class="row">
                  <label class="pb-6px f-12 _fw-600" for="lead_category">Sales Related Notes</label>
                  <p class="text-capitalize _fw-400">{{ EOI_form.controls['sales_related_notes'].value }}</p>
                </div>
              </div>
            </div>
            <div class="col-sm-6 pl-3" *ngIf="userRole?.toLowerCase() == 'master admin' || userRole?.toLowerCase() == 'operations manager'">
              <div class="popup-box">
                <div class="row">
                  <div class="col-sm-12">
                    <label class="pb-6px f-12 _fw-600" for="lead_category">Commission Comments <i class="pi pi-lock f-10 ml-1"></i></label>
                    <p class="text-capitalize _fw-400">{{ EOI_form.controls['commission_comments'].value }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </div>
      <div
        class="tab-pane fade  {{ tabIndexValue === 3 ? 'show active' : '' }}"
        [id]="'files' + eoiTabIndex"
        role="tabpanel"
        [attr.aria-labelledby]="'pills-files-tab' + eoiTabIndex"
        tabindex="0">
        <div class="my-3" *ngIf="tabIndexValue === 3">
          <app-library-menu [propertyId]="this.selected_EOI?.projectid"></app-library-menu>
          <app-library-view-mode
            category="useroffice"
            [defaultopen]="'eoi'"
            [innerdefault]="eoi_status_folder"
            [nestedInnerDefault]="eoi_folder"
            [eoi_Id]="this.selected_EOI?._id"
            [propertyId]="this.selected_EOI?.projectid">
          </app-library-view-mode>
        </div>
      </div>
      <div
        class="tab-pane fade  {{ tabIndexValue === 4 ? 'show active' : '' }}"
        [id]="'leads' + eoiTabIndex"
        role="tabpanel"
        [attr.aria-labelledby]="'pills-leads-tab' + eoiTabIndex"
        tabindex="0">
        <div class="my-3">
          <p-table styleClass="pagination-dropdown" scrollWidth="100%" dataKey="_id" [value]="eoiLeadList">
            <ng-template pTemplate="colgroup">
              <colgroup>
                <col style="width: 200px" />
                <col style="width: 200px" />
                <col style="width: 250px" />
                <col style="width: 150px" />
                <col style="width: 150px" />
                <col style="width: 200px" />
                <col style="width: 150px" />
                <col style="width: 150px" />
              </colgroup>
            </ng-template>
            <ng-template pTemplate="header">
              <tr>
                <th pSortableColumn="status_type">
                  <div class="d-flex align-items-center justify-content-between">
                    <p>Project</p>
                    <p-sortIcon field="status_type"></p-sortIcon>
                  </div>
                </th>
                <th pSortableColumn="first_name">
                  <div class="d-flex align-items-center justify-content-between">
                    <p>Full Name</p>
                    <p-sortIcon field="first_name"></p-sortIcon>
                  </div>
                </th>
                <th pSortableColumn="email">
                  <div class="d-flex align-items-center justify-content-between">
                    <p>Email</p>
                    <p-sortIcon field="email"></p-sortIcon>
                  </div>
                </th>
                <th pSortableColumn="mobile_phone">
                  <div class="d-flex align-items-center justify-content-between">
                    <p>Mobile Phone</p>
                    <p-sortIcon field="mobile_phone"></p-sortIcon>
                  </div>
                </th>
                <th pSortableColumn="lead_status">
                  <div class="d-flex align-items-center justify-content-between">
                    <p>Lead Status</p>
                    <p-sortIcon field="lead_status"></p-sortIcon>
                  </div>
                </th>
                <th pSortableColumn="lead_source">
                  <div class="d-flex align-items-center justify-content-between">
                    <p>Lead Type</p>
                    <p-sortIcon field="lead_source"></p-sortIcon>
                  </div>
                </th>
                <th pSortableColumn="agent_responsible">
                  <div class="d-flex align-items-center justify-content-between">
                    <p>Agent</p>
                    <p-sortIcon field="agent_responsible"></p-sortIcon>
                  </div>
                </th>
                <th pSortableColumn="created_at">
                  <div class="d-flex align-items-center justify-content-between">
                    <p>Created Date</p>
                    <p-sortIcon field="created_at"></p-sortIcon>
                  </div>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-projectLead>
              <tr (dblclick)="notOpen()">
                <td class="pl-3 cursor-pointer" (click)="editRecord(projectLead)">
                  <p>{{ projectLead?.listing_id ? projectLead?.listing : projectLead?.listing_project?.project }}</p>
                </td>
                <td class="pl-3 cursor-pointer" (click)="editRecord(projectLead)">
                  <p>{{ projectLead?.full_name }}</p>
                </td>
                <td class="pl-3 cursor-pointer" (click)="editRecord(projectLead, 'email')">
                  <p *ngIf="projectLead?.email" (click)="projectLead.isOpen = !projectLead.isOpen">
                    {{ projectLead.isOpen ? (projectLead?.email | slice: 0 : 25) : projectLead?.email }}
                  </p>
                </td>
                <td class="pl-3 cursor-pointer" (click)="editRecord(projectLead)">
                  <p>{{ projectLead?.mobile_phone }}</p>
                </td>
                <td class="pl-3 cursor-pointer" (click)="editRecord(projectLead)">
                  <p>{{ projectLead?.lead_status }}</p>
                </td>
                <td class="pl-3 cursor-pointer" (click)="editRecord(projectLead)">
                  <p>{{ projectLead?.lead_type }}</p>
                </td>
                <td class="pl-3 cursor-pointer" (click)="editRecord(projectLead)">
                  <p>{{ projectLead?.agent_responsible }}</p>
                </td>
                <td class="pl-3 cursor-pointer" (click)="editRecord(projectLead)">
                  <p>{{ projectLead?.created_at | date: 'd/M/yyyy, h:mm a' }}</p>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="7">{{ isLoad == true ? 'Loading' : 'No record found' }}</td>
              </tr>
            </ng-template>
          </p-table>
          <div class="mt-4">
            <p *ngIf="eoiLeadList?.length > 0">{{ 'Records: ' + total_lead }}</p>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
